import { useEffect, useState } from 'react';

export const useAllImagesLoaded = (hasPageLoaded = true) => {
  const [haveAllImagesLoaded, setHaveAllImagesLoaded] = useState(false);

  useEffect(() => {
    if (!hasPageLoaded) return;

    const imagesInDocument = Array.from(document.getElementsByTagName('img'));
    const totalImageCount = imagesInDocument.length;

    if (totalImageCount === 0) {
      setHaveAllImagesLoaded(true);
      return;
    }

    let loadedImageCount = 0;

    const handleImageLoad = () => {
      loadedImageCount++;
      if (loadedImageCount === totalImageCount) {
        setHaveAllImagesLoaded(true);
      }
    };

    imagesInDocument.forEach(imageElement => {
      if (imageElement.complete) {
        handleImageLoad();
      } else {
        imageElement.addEventListener('load', handleImageLoad);
        imageElement.addEventListener('error', handleImageLoad);
      }
    });

    return () => {
      imagesInDocument.forEach(imageElement => {
        imageElement.removeEventListener('load', handleImageLoad);
        imageElement.removeEventListener('error', handleImageLoad);
      });

      setHaveAllImagesLoaded(false);
    };
  }, [hasPageLoaded]);

  return haveAllImagesLoaded;
};
